module.exports = __webpack_public_path__ + "static/media/logo-ai2-fullColor-withText-micro.ef68549b.svg";